@if (src) {
  <div class="iframe-box">
    <iframe [src]="src" [ngStyle]="{'width': data.width || '100%', 'height': data.height || '500px' }">
    </iframe>
    <div class="form-inline cald_dialog_buttonbar">
      <button type="button" id="closeIframeDialog" class="btn btn-primary fiori3-btn-primary" (click)="close()">{{'Msg.OK' | translate}}</button>
    </div>
  </div>
}